import { createStore } from 'vuex'
import { users } from './modules/users'
import { invoices } from './modules/invoices'
import { properties } from './modules/properties'
import { appointments } from './modules/appointments'

export default createStore({

    state: {

        base_url: 'https://portal-stage.clinichq.com/',

        auth: null || localStorage.getItem('token'),

        search: '',
        searchOptions: [
            {
                id: 1,
                name: 'Animal Owner'
            },
            {
                id: 2,
                name: 'Animal Name'
            },
            {
                id: 3,
                name: 'Animal Clinic'
            }
        ],

        banner: true,
        bannerRoutesList: [ 'Appointments', 'Invoices' ],

        clinics: []

    },

    getters: {
        isAuth: (state) => !!state.auth
    },

    mutations: {

        setAuth(state, auth) { state.auth = auth },
        setSearch(state, search) { state.search = search },
        setBanner(state, banner) { state.banner = banner },
        setClinics(state, clinics) { state.clinics = clinics }

    },

    actions: {

        // Fetch wraper with base url and bearer header

        async fetchy( ctx, config )  {

            let options = { ...config.options }

            // If User is authenthicated set bearer token to all requests

            if ( ctx.getters.isAuth ) {

                const authHeader = { Authorization: `Bearer ${ctx.state.auth}` }

                if ( options.headers ) options.headers = { ...options.headers, ...authHeader }
                else options.headers = authHeader

            }

            const request = await fetch( ctx.state.base_url + config.url, options )
            const response = await request.json()

            return response

        },

        async getClinics( { state, commit, dispatch } ) {

            const clinics = await dispatch( 'fetchy', { 
                url: 'api/clinics',
                options: {
                    headers: {
                        Authorization: `Bearer ${state.auth}`
                    }
                }
            })

            console.log(clinics)

            commit('setClinics', clinics)

            return clinics

        }

    },

    modules: {
        users,
        invoices,
        properties,
        appointments
    }

})
